import * as React from 'react';
import { Alert, AlertTitle } from '@mui/material';

// project import
import MainCard from 'components/MainCard';


const NotFound = () => {

    return (
        <MainCard>
            <Alert severity="error" color="error" sx={{ border: "1px solid #f0f0f0" }}>
                <AlertTitle sx={{ fontSize: "24px" }}>404 - Not Found</AlertTitle>
                The page you are looking for can`t be found.
            </Alert>
        </MainCard>

    );
}

export default NotFound;